import { render, staticRenderFns } from "./DeleteSubCategory.vue?vue&type=template&id=038cd57a&scoped=true"
import script from "./DeleteSubCategory.vue?vue&type=script&lang=js"
export * from "./DeleteSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038cd57a",
  null
  
)

export default component.exports